import { FC, ReactNode } from "react";
import arrowIcon from "../../icons/arrow.png";
import styles from "./Tasks.module.scss";
import { Highlightable } from "../../components/Highlight/Highlightable";
import { ActionPromptType } from "../../hooks/prompts";

export interface ITaskTypeBlockProps {
    handler?: () => void,
    icon: string;
    name: string | ReactNode;
    description: ReactNode;
    iconTypeStyle: 'iconTypeTelegram' | 'iconTypeMax' | 'iconTypeFriends' | 'iconTypeVk' | 'iconTypeQuiz' | 'iconTypeHomescreen';
    promptType?: ActionPromptType;
}

export const TaskTypeBlock: FC<ITaskTypeBlockProps> = ({ handler, name, description, icon, iconTypeStyle, promptType = ActionPromptType.NONE }) => {
    return (
        <Highlightable promptType={ promptType } >
            <div
                className={styles.taskItem}
                onClick={ handler }
            >
                <div className={`${styles.iconWrapper} ${styles[iconTypeStyle]}`}>
                    <img
                        src={icon}
                        alt={name?.toString()}
                        className={styles.icon}
                    />                
                </div>

                <div className={styles.taskDetails}>
                    <h3 className={styles.taskTitle}>{name}</h3>
                    <p className={styles.taskStatus}>
                        { description }                    
                    </p>
                </div>

                <img src={arrowIcon} alt="arrow" className={styles.arrowIcon} />
            </div>
        </Highlightable>
    );
}